import type { ApiResponse } from '~/types/shared/ApiResponse'
import type { AnnouncementBannerModel } from '~/models'
import type { IContentItemsContainer } from '@kontent-ai/delivery-sdk'

interface AnnouncementState {
  announcements: AnnouncementBannerModel[]
  linkedItems: IContentItemsContainer | undefined
}

export const useAnnouncementStore = defineStore('announcement', {
  state: (): AnnouncementState => ({
    announcements: [],
    linkedItems: undefined
  }),
  actions: {
    async fetchData() {
      const response =
        await $fetch<
          ApiResponse<{ items: AnnouncementBannerModel[]; linkedItems: IContentItemsContainer }>
        >('/api/announcements')
      this.announcements = response.data?.items ?? []
      this.linkedItems = response.data?.linkedItems
    }
  },
  getters: {
    getAnnouncements: (state) => (): AnnouncementBannerModel[] => {
      return state.announcements
    },
    getListAs:
      (state) =>
      <T>(codenames: string[] | undefined) => {
        if (codenames && codenames.length > 0) {
          return codenames.map((codename) => state.linkedItems?.[codename] as T).filter((x) => x)
        }
        return []
      }
  }
})
